import { ActionTree } from 'vuex';
import { getFinancialInstitution } from '@/api/financial-institution.api';
import { FinancialInstitutionState, FinancialInstitution } from './types';
import { RootState } from '../types';

export const actions: ActionTree<FinancialInstitutionState, RootState> = {
  fetchData({ commit }, tokenId) {
      return getFinancialInstitution(tokenId)
      .then((response) => {
        const payload: FinancialInstitution = {
          displayName: response.data.data.displayName,
          logoFullUrl: response.data.data.logoFullUrl,
          id: response.data.data.id,
          iconUri: response.data.data.iconUri,
          logoUri: response.data.data.logoUri,
          homepageURL: response.data.data.homepageURL,
          privacyPolicyURL: response.data.data.privacyPolicyURL,
          addressLine1: response.data.data.addressLine1,
          addressLine2: response.data.data.addressLine2,
          city: response.data.data.city,
          state: response.data.data.state,
          zipcode: response.data.data.zipcode,
          phoneNumber: response.data.data.mainContactPhone,
          kasasaFiConfigId: response.data.data.kasasaFiConfigId,
          
        };
        commit('financialInstitutionLoaded', payload);
      }, (error) => {
      commit('financialInstitutionError', error);
    });
  },
};

export default actions;
